import { isApiError } from '@/api/http/errors';
import { josa } from './josa';

export interface LoadErrorDescription {
  title: string;
  description: string;
  /** 같은 요청을 다시 보내면 결과가 달라질 수 있는가 — 권한 거부·없는 대상은 아니다. */
  retryable: boolean;
}

/**
 * 조회 실패를 화면 문구로 바꾼다. 서버 메시지를 그대로 보여 주지 않고(제출값·내부 정보가 섞일 수 있다),
 * 문의에 쓸 요청 ID만 덧붙인다.
 */
export function describeLoadError(error: unknown, subject: string): LoadErrorDescription {
  const requestId = isApiError(error) ? error.requestId : undefined;
  const support = requestId ? ` 문의할 때 요청 ID ${requestId}를 알려 주세요.` : '';
  if (isApiError(error)) {
    if (error.status === 403)
      return {
        title: `${subject} 조회 권한이 없습니다`,
        description: `관리자에게 권한을 확인해 주세요.${support}`,
        retryable: false,
      };
    if (error.status === 404)
      return {
        title: `${josa(subject, '을/를')} 찾을 수 없습니다`,
        description: `삭제되었거나 주소가 올바르지 않을 수 있습니다.${support}`,
        retryable: false,
      };
    if (error.status === 503)
      return {
        title: `${subject} 서비스를 사용할 수 없습니다`,
        description: `잠시 후 다시 시도해 주세요.${support}`,
        retryable: true,
      };
    if (error.kind === 'invalid-response')
      return {
        title: `${josa(subject, '을/를')} 읽지 못했습니다`,
        description: `받은 내용의 형식이 달라 표시할 수 없습니다. 반복되면 관리자에게 문의해 주세요.${support}`,
        retryable: true,
      };
    if (error.kind === 'network' || error.kind === 'timeout')
      return {
        title: '연결하지 못했습니다',
        description: '네트워크 상태를 확인한 뒤 다시 시도해 주세요.',
        retryable: true,
      };
  }
  return {
    title: `${josa(subject, '을/를')} 불러오지 못했습니다`,
    description: `잠시 후 다시 시도해 주세요.${support}`,
    retryable: true,
  };
}
